(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (() => {
    const recentKey = 'aroma_dakota_recent_product_v1';
    const seenKey = 'aroma_dakota_seen_v1';
    const dismissedKey = 'aroma_dakota_offer_dismissed_v1';
    const fourteenDays = 14 * 24 * 60 * 60 * 1000;

    document.querySelectorAll('[data-ad-product-view]').forEach((node) => {
      try {
        const product = JSON.parse(node.textContent);
        product.savedAt = Date.now();
        localStorage.setItem(recentKey, JSON.stringify(product));
      } catch (error) {
        return;
      }
    });

    let returningVisitor = false;
    try {
      returningVisitor = localStorage.getItem(seenKey) === 'true';
      localStorage.setItem(seenKey, 'true');
    } catch (error) {
      returningVisitor = false;
    }

    document.querySelectorAll('[data-ad-scroll-offer]').forEach((offer) => {
      try {
        if (sessionStorage.getItem(dismissedKey) === 'true') return;
      } catch (error) {
        return;
      }

      const kicker = offer.querySelector('[data-offer-kicker]');
      const title = offer.querySelector('[data-offer-title]');
      const price = offer.querySelector('[data-offer-price]');
      const image = offer.querySelector('.ad-scroll-offer__image');
      const links = offer.querySelectorAll('[data-offer-link]');
      const variant = offer.querySelector('[data-offer-variant]');
      const form = offer.querySelector('[data-offer-form]');
      const button = offer.querySelector('[data-offer-button]');
      const cartLink = offer.querySelector('[data-offer-cart]');
      let recentProduct = null;

      try {
        recentProduct = JSON.parse(localStorage.getItem(recentKey));
      } catch (error) {
        recentProduct = null;
      }

      const validRecentProduct = recentProduct
        && recentProduct.available === true
        && Number.isFinite(recentProduct.savedAt)
        && Date.now() - recentProduct.savedAt < fourteenDays
        && typeof recentProduct.url === 'string'
        && recentProduct.url.startsWith('/products/')
        && /^\d+$/.test(String(recentProduct.variantId));

      if (validRecentProduct) {
        title.textContent = recentProduct.title;
        price.textContent = recentProduct.price;
        variant.value = recentProduct.variantId;
        links.forEach((link) => link.setAttribute('href', recentProduct.url));
        if (image && typeof recentProduct.image === 'string') {
          if (recentProduct.image.startsWith('https://') || recentProduct.image.startsWith('//')) {
            image.src = recentProduct.image;
            image.alt = recentProduct.title;
          }
        }
        kicker.textContent = offer.dataset.recentLabel;
      } else if (offer.dataset.customer === 'true') {
        kicker.textContent = offer.dataset.customerLabel;
      } else if (returningVisitor) {
        kicker.textContent = offer.dataset.returningLabel;
      } else {
        kicker.textContent = offer.dataset.newLabel;
      }

      const reveal = () => {
        const scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, 0);
        const threshold = Number(offer.dataset.scrollThreshold || 35) / 100;
        const revealAt = Math.min(scrollable * threshold, window.innerHeight * 0.9);
        if (window.scrollY >= revealAt) {
          offer.hidden = false;
          requestAnimationFrame(() => offer.classList.add('is-visible'));
          window.removeEventListener('scroll', reveal, { passive: true });
        }
      };

      window.addEventListener('scroll', reveal, { passive: true });
      reveal();

      offer.querySelector('[data-offer-close]').addEventListener('click', () => {
        offer.classList.remove('is-visible');
        try {
          sessionStorage.setItem(dismissedKey, 'true');
        } catch (error) {
          return;
        }
        window.setTimeout(() => {
          offer.hidden = true;
        }, 180);
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        button.disabled = true;
        button.textContent = button.dataset.loadingLabel;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: Number(variant.value), quantity: 1 }]
            })
          });

          if (!response.ok) throw new Error('Cart request failed');
          button.textContent = button.dataset.successLabel;
          cartLink.hidden = false;
        } catch (error) {
          button.textContent = button.dataset.defaultLabel;
        } finally {
          button.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
